import { createContext, useContext } from "react";

export type AuthAction = () => void | Promise<void>;

export type NkuliAuthContextValue = {
  providerLoading: boolean;
  providerAuthenticated: boolean;
  signIn: AuthAction;
  signUp: AuthAction;
  signOut: AuthAction;
};

export const NkuliAuthContext = createContext<NkuliAuthContextValue | null>(
  null,
);

export function useNkuliAuth() {
  const value = useContext(NkuliAuthContext);

  if (!value) {
    throw new Error("useNkuliAuth must be used inside NkuliAuthProvider.");
  }

  return value;
}
